import 'react-dates/initialize';
import React, { Component } from 'react';
import 'react-dates/lib/css/_datepicker.css';
import moment from '../utils/momentTimeZone';
import SelectRefinement from './SelectRefinement';

class FilterBy extends Component {

    constructor(props) {
        super(props)
        this.state = {
            startDate: moment(),
            endDate: null,
            focusedInput: null
        }
    }

    render() {
        return (
            <div className="c-whats-on--filterby">
                <div className="c-event-filter__venue">
                    <SelectRefinement operator="or" attribute="attendable.venues" placeholder="Venue" />
                </div>
                <div className="c-event-filter__access">
                    <SelectRefinement operator="or" attribute="attendable.access" placeholder="Access" />
                </div>
            </div>
        );
    }
}

export default FilterBy;



// WEBPACK FOOTER //
// ./src/whatson/components/FilterBy.js